import React from "react";
import "./SuitableFor.css";

const items = [
    {
        title: "Canvas Shoes",
        img:"/service/shoe4-2048x1417.webp",
        desc:"50 + VAT"
    },

    {
        title: "Designer Formal Shoes",
        img: "/service/shoe1-2048x1417.webp",
        desc:" 30 + VAT"
    },
    {
        title: "Oxford Sneakers",
        img: "/service/shoe2-2048x1417.webp",
        desc:"30 + VAT"
    },

    {
        title: "Runing Shoes",
        img: "/service/shoe3-2048x1417.webp",
        desc:" 40 + VAT"
    },

    {
        title: "Slip on shoes",
        img: "/service/shoe5-2048x1417.webp",
        desc:" 40 + VAT"
    }
    ,

    // {
    //     title: "Cashmere",
    //     img: "https://5asec.ae/wp-content/uploads/2025/11/shoe6-scaled.png",
    //     desc:"120 + VAT"
    // }


 


];

export default function FromSneakers() {

    const DirhamIcon = () => (
  <svg width="14" height="14" viewBox="0 0 100 100">
    <path
      d="M20 10 L20 90 Q80 90 80 50 Q80 10 20 10"
      stroke="#5a0b64"
      strokeWidth="10"
      fill="none"
    />
    <line x1="20" y1="40" x2="100" y2="40" stroke="#5a0b64" strokeWidth="10" />
    <line x1="20" y1="60" x2="100" y2="60" stroke="#5a0b64" strokeWidth="10" />
  </svg>
);
    return (
        <section className="fromsneakers-section">
            <h3 className="expertise-title">
                From Sneakers to Stilettos - Expert Care for Every Pair
            </h3>
            <p className="subtitle" style={{ fontSize: "15px" }}>
                From athletic sneakers and leather oxfords to suede boots and designer heels, our professional shoe cleaning services handle it all. We deep clean, deodorize, polish, and restore shoes of every material and style with expert precision.      </p>

            <div className="fromsneakers-grid">
                {items.map((item, i) => (
                    <div className="fromsneakers-card" key={i}>
                        <div className="fromsneakers-box">
                            <img src={item.img} alt={item.title} />
                        </div>
                        <h3>{item.title}</h3>
                        <p>{item.desc} <DirhamIcon /></p>
                    </div>
                ))}
            </div>
        </section>
    );
}
